import {Controller} from "@hotwired/stimulus";
import flatpickr from "flatpickr";
import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect'
import shortcutButtons from 'shortcut-buttons-flatpickr'

export default class FlatpickrController extends Controller {
  static ELEMENT_ID = 'period';

  static values = {
    mode: {type: String, default: 'single'},
    enableTime: {type: Boolean, default: false},
    monthSelect: {type: Boolean, default: false},
    minDate: {type: String, default: ''},
    maxDate: {type: String, default: ''}
  }

  connect() {
    this.render();
  }

  disconnect() {
    this.ele._flatpickr.destroy()
    super.disconnect();
  }

  render() {
    if (!this.ele) return;
    let locale = {firstDayOfWeek: 1}
    let plugins = []
    if (this.monthSelectValue) {
      plugins.push(new monthSelectPlugin({
        shorthand: false, //defaults to false
        dateFormat: "Y-m-01", //defaults to "F Y"
        altFormat: "F Y", //defaults to "F Y"
      }))

    }
      plugins.push(shortcutButtons({
        theme: 'material_green',
        button: [
          { label: 'Today', attributes: {class: 'btn btn-sm btn-secondary'} },
          { label: 'Tomorrow', attributes: {class: 'btn btn-sm btn-secondary'} }
        ],
        onClick(index, fp) {
          let date = index ? new Date(Date.now() + 24 * index * 60 * 60 * 1000) : new Date;

          fp.setDate(date);
          fp.close();
        }
      }))

    flatpickr(this.ele,
        {
          mode: this.modeValue,
          enableTime: this.enableTimeValue,
          locale: locale,
          time_24hr: true,
          plugins: plugins,
          minDate: this.minDateValue,
          maxDate: this.maxDateValue
        });
  }

  get ele() {
    return this._ele = this._ele || document.getElementById(FlatpickrController.ELEMENT_ID) || this.element;
  }

  change(event) {
    if (this.modeValue === 'range') {
      let period = event.target._flatpickr.selectedDates;
      $(document).trigger('flatpickr.periodChanged', {from: period[0], to: period[1]})
    }
  }

}